'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _stylecomponents = require('../../stylecomponents');

var _reactImageLightbox = require('react-image-lightbox');

var _reactImageLightbox2 = _interopRequireDefault(_reactImageLightbox);

require('react-image-lightbox/style.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*=====================================
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   FullImageModal
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   Author: Gray
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   CreateTime: 2018 / 10 / 25
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               =====================================*/

/*--------------------------
    Import
--------------------------*/


/*--------------------------
    Variable
--------------------------*/
var React_Modal_Style = {
    overlay: {
        zIndex: _stylecomponents.GlobalStyle.ModalDefaultZIndex + 1
    }
};

/*--------------------------
    Component
--------------------------*/

var FullImageModal = function (_Component) {
    _inherits(FullImageModal, _Component);

    // ------------------------------
    // constructor
    // ------------------------------
    function FullImageModal(props) {
        _classCallCheck(this, FullImageModal);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        var _this$props$currentId = _this.props.currentIdx,
            currentIdx = _this$props$currentId === undefined ? 0 : _this$props$currentId;


        _this.state = {
            currentIdx: currentIdx
        };

        _this.getCurrentImage = _this.getCurrentImage.bind(_this);
        _this.getPrevImage = _this.getPrevImage.bind(_this);
        _this.getNextImage = _this.getNextImage.bind(_this);
        _this.close = _this.close.bind(_this);
        _this.prev = _this.prev.bind(_this);
        _this.next = _this.next.bind(_this);
        return _this;
    }

    // ------------------------------
    // 取得目前的圖片
    // ------------------------------


    FullImageModal.prototype.getCurrentImage = function getCurrentImage() {
        var currentIdx = this.state.currentIdx;
        var _props$images = this.props.images,
            images = _props$images === undefined ? [] : _props$images;


        return images[currentIdx];
    };

    // ------------------------------
    // 取得上一張的圖片
    // ------------------------------


    FullImageModal.prototype.getPrevImage = function getPrevImage() {
        var currentIdx = this.state.currentIdx;
        var _props$images2 = this.props.images,
            images = _props$images2 === undefined ? [] : _props$images2;


        var prev = currentIdx - 1;

        return images[prev];
    };

    // ------------------------------
    // 取得下一張的圖片
    // ------------------------------


    FullImageModal.prototype.getNextImage = function getNextImage() {
        var currentIdx = this.state.currentIdx;
        var _props$images3 = this.props.images,
            images = _props$images3 === undefined ? [] : _props$images3;


        var next = currentIdx + 1;

        return images[next];
    };

    // ------------------------------
    // 關閉
    // ------------------------------


    FullImageModal.prototype.close = function close(event) {
        var closeCallback = this.props.closeCallback;

        // setTimeout(() => {

        closeCallback();
        // }, 250);
    };

    // ------------------------------
    // 上一張
    // ------------------------------


    FullImageModal.prototype.prev = function prev() {
        var currentIdx = this.state.currentIdx;


        this.setState({
            currentIdx: currentIdx - 1
        });
    };

    // ------------------------------
    // 下一張
    // ------------------------------


    FullImageModal.prototype.next = function next() {
        var currentIdx = this.state.currentIdx;


        this.setState({
            currentIdx: currentIdx + 1
        });
    };

    // ------------------------------
    // render
    // ------------------------------    


    FullImageModal.prototype.render = function render() {

        var current = this.getCurrentImage();
        var prev = this.getPrevImage();
        var next = this.getNextImage();

        return _react2.default.createElement(_reactImageLightbox2.default, {
            mainSrc: current,
            prevSrc: prev,
            nextSrc: next,
            onCloseRequest: this.close,
            onMovePrevRequest: this.prev,
            onMoveNextRequest: this.next,
            reactModalStyle: React_Modal_Style
        });
    };

    return FullImageModal;
}(_react.Component);

/*--------------------------
    Props
--------------------------*/


FullImageModal.propTypes = process.env.NODE_ENV !== "production" ? {
    closeCallback: _propTypes2.default.func.isRequired,
    images: _propTypes2.default.array.isRequired,
    currentIdx: _propTypes2.default.number
} : {};

FullImageModal.defaultProps = {
    images: [],
    currentIdx: 0
};

/*--------------------------
    Export
--------------------------*/
exports.default = FullImageModal;
module.exports = exports['default'];